import { Record as record } from 'immutable';

import { DelayRepayPaymentMethod, DelayRepayBankPeriod } from '../../../src/constants/AppConstants';
import ValidationMixin from '../../../src/records/ValidationMixin';
import validators from '../../../src/validation';
import { construct, fields, resolve } from '../../../src/helpers/LinkMapper';
import { getResolvers, getDefaults } from '../../../src/helpers/Records';
import PaymentMethod from './PaymentMethod';
import FeatureFlagStore from '../../../src/stores/FeatureFlagStore';

const fieldSchema = {
    paymentMethod: [ resolve.as(PaymentMethod) ],
    bacsSortCode: [ fields.string ],
    bacsAccountNumber: [ fields.string ],
    bacsValidated: [ fields.bool ],
    paypalEmail: [ fields.string ],
    agreeTerms: [ fields.string ],
    bankPeriod: [ fields.string, DelayRepayBankPeriod.NONE ],
    charity: [ fields.string ]
};

class DelayRepayPayment extends record(getDefaults(fieldSchema)) {

    static fromJSON (json = {}) {
        return construct(DelayRepayPayment, json, getResolvers(fieldSchema));
    }

    get paymentMethodId () {
        return this.getIn(['paymentMethod', 'id']);
    }

    getComputedValues () {
        const paymentMethodDisabled = Boolean(this.getIn(['paymentMethod', 'disabled']));
        return {
            paymentMethod: paymentMethodDisabled ? '' : this.paymentMethodId
        };
    }

    getSchema () {
        const paymentMethods = Object.values(DelayRepayPaymentMethod);

        let schema = {
            paymentMethod: validators.allowOnly(paymentMethods).required(),
            agreeTerms: validators.true().required()
        };

        if (this.paymentMethodId === DelayRepayPaymentMethod.BACS) {
            Object.assign(schema, {
                bacsSortCode: validators.required(),
                bacsAccountNumber: validators.required()
            });

            if (FeatureFlagStore.get('enableBacsValidation')) {
                Object.assign(schema, {
                    bacsValidated: validators.true().required()
                });
            }
        }
        else if (this.paymentMethodId === DelayRepayPaymentMethod.PAYPAL) {
            schema.paypalEmail = validators.email();
        }
        else if (this.paymentMethodId === DelayRepayPaymentMethod.CHARITY) {
            schema.charity = validators.required();
        }

        return schema;
    }

    isBankable () {
        return this.paymentMethod && this.paymentMethod.isBankable;
    }

    serialize () {
        let serialized = {
            method: this.paymentMethodId
        };
        if (this.paymentMethodId === DelayRepayPaymentMethod.BACS) {
            Object.assign(serialized, {
                sortCode: this.bacsSortCode.replace(/[\s-]+/g, ''),
                accountNumber: this.bacsAccountNumber.trim()
            });
        } else if (this.paymentMethodId === DelayRepayPaymentMethod.PAYPAL) {
            Object.assign(serialized, {
                paypalEmail: this.paypalEmail
            });
        } else if (this.paymentMethodId === DelayRepayPaymentMethod.CHARITY) {
            serialized = { ...serialized, charity: this.charity };
        }
        return serialized;
    }
}

Object.assign(DelayRepayPayment.prototype, ValidationMixin);

export default DelayRepayPayment;
